import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/oauth2/deviceCode.ts
const applicationSlugSchema = z.object({ applicationSlug: z.string() });
const applicationInfoSchema = z.object({
	id: z.string(),
	name: z.string(),
	slug: z.string(),
	description: z.string().optional(),
	logoMediaId: z.string().optional(),
	homepageUrl: z.url().optional()
});
const deviceAuthorizationInputSchema = applicationSlugSchema.extend({ scope: z.string().optional().meta({ description: "Space-separated list of scopes" }) });
const deviceAuthorizationOutputSchema = z.object({
	device_code: z.string(),
	user_code: z.string(),
	verification_uri: z.url(),
	verification_uri_complete: z.url().optional(),
	expires_in: z.number().int(),
	interval: z.number().int().optional()
});
const deviceVerifyInputSchema = applicationSlugSchema.extend({ user_code: z.string() });
const deviceVerifyOutputSchema = z.object({
	user_code: z.string(),
	application: applicationInfoSchema,
	scopes: z.array(z.string())
});
const deviceConsentInputSchema = applicationSlugSchema.extend({
	user_code: z.string(),
	approved: z.boolean(),
	remember: z.boolean().optional()
});
const deviceConsentApprovedSchema = z.object({ approved: z.literal(true) });
const deviceConsentDeniedSchema = z.object({ approved: z.literal(false) });
const deviceConsentOutputSchema = z.discriminatedUnion("approved", [deviceConsentApprovedSchema, deviceConsentDeniedSchema]);
const tokenDeviceCodeInputSchema = applicationSlugSchema.extend({
	grant_type: z.literal("urn:ietf:params:oauth:grant-type:device_code"),
	device_code: z.string()
});
const deviceCodeErrors = {
	invalid_scope: {
		status: 400,
		message: "Invalid scope"
	},
	unauthorized_client: {
		status: 400,
		message: "Client not authorized for device code grant"
	},
	invalid_request: {
		status: 400,
		message: "Invalid request"
	},
	expired_token: {
		status: 400,
		message: "Device code has expired"
	}
};
const deviceAuthorizationContract = oc.route({
	summary: "OAuth2 device authorization request",
	description: "Request a device code and user code for the device authorization flow (RFC 8628). Auth: HTTP Basic (Authorization: Basic base64(client_id:client_secret)).",
	method: "POST",
	path: "/{applicationSlug}/device_authorization"
}).input(deviceAuthorizationInputSchema).output(deviceAuthorizationOutputSchema).errors(deviceCodeErrors);
const deviceVerifyContract = oc.route({
	summary: "Verify a device user code",
	description: "Look up a device authorization request by user_code and return application info. Auth: requires authenticated user session (cookie).",
	method: "POST",
	path: "/{applicationSlug}/device/verify"
}).input(deviceVerifyInputSchema).output(deviceVerifyOutputSchema).errors(deviceCodeErrors);
const deviceConsentContract = oc.route({
	summary: "Approve or deny a device authorization",
	description: "Record user consent decision for a device code. Auth: requires authenticated user session (cookie).",
	method: "POST",
	path: "/{applicationSlug}/device/consent"
}).input(deviceConsentInputSchema).output(deviceConsentOutputSchema).errors(deviceCodeErrors);
//#endregion
export { applicationInfoSchema, applicationSlugSchema, deviceAuthorizationContract, deviceConsentContract, deviceVerifyContract, tokenDeviceCodeInputSchema };
